const marketingPagesData = [
    {
        id: '01',
        imageUrl: 'https://www.spireon.com/wp-content/uploads/10470566-FleetLocate_LoginBanners_FL360-1024x430.jpg',
        imageAlt: 'FleetLocate FL360 banner',
        heading: 'Vehicle & Driver Intelligence for Any Vehicle Type',
        description: 'Our FL360 is a modular GPS tracking device that supports light, medium, and heavy-duty vehicles.',
        buttonText: 'See For Yourself',
        buttonLink: 'https://www.spireon.com/products/fleetlocate-for-fleet-managers/fl-360/',
    },
    {
        id: '02',
        imageUrl: 'https://www.spireon.com/wp-content/uploads/10470566-FleetLocate_LoginBanners_FlexBatteryTracker-1024x430.jpg',
        imageAlt: 'FleetLocate Flex Battery Tracker banner',
        heading: 'The New Flex Battery Tracker',
        description: 'The Flex Battery Tracker sets a new standard with increased durability, extended battery life, and advanced theft prevention measures for unpowered assets such as trailers, equipment, containers, and more.',
        buttonText: 'Get Resources',
        buttonLink: 'https://www.spireon.com/flex-battery-tracker/',
    },
    {
        id: '03',
        imageUrl: 'https://www.spireon.com/wp-content/uploads/10470566-FleetLocate_LoginBanners_CamCoach-1024x430.jpg',
        imageAlt: 'FleetLocate CamCoach AI Dashcam banner',
        heading: 'AI Dashcam for Fleets',
        description: 'CamCoach is designed to coach your drivers on the go. Get access to video recordings from anywhere. A detailed view of distracted driving events are also available so you can reduce liability risk, encourage safe driving, reduce insurance premiums, and reduce costs of claims.',
        buttonText: 'Learn More',
        buttonLink: 'https://www.spireon.com/products/fleetlocate-for-fleet-managers/camcoach/',
    },
    {
        id: '04',
        imageUrl: 'https://www.spireon.com/wp-content/uploads/10470566-FleetLocate_LoginBanners_Flex2-1024x430.jpg',
        imageAlt: 'FleetLocate Flex 2 banner',
        heading: 'Trailer and Asset Tracking',
        description: 'Increase profitability and protect your assets from misuse or theft, with Flex 2. This covert GPS tracking device combines with intelligent cloud software, to give you actionable insights so you can make smarter business decisions faster.',
        buttonText: 'See For Yourself',
        buttonLink: 'https://www.spireon.com/products/fleetlocate-for-fleet-managers/fl-flex-2/',
    },
    {
        id: '05',
        imageUrl: 'https://www.spireon.com/wp-content/uploads/10470566-FleetLocate_LoginBanners_ELD-1024x430.jpg',
        imageAlt: 'FleetLocate ELD and DVIR compliance banner',
        heading: 'Simplify Compliance with ELD & DVIR',
        description: 'Activate FL Compliance with Spireon’s FL360 to comply with the ELD Mandate, Hours of Service (HOS), Driver Vehicle Inspection Reporting (DVIR), and the International Fuel Tax Agreement (IFTA). Stay compliant, track your fleet, and monitor driver behavior from one online portal.',
        buttonText: 'Get Resources',
        buttonLink: 'https://www.spireon.com/solutions/fleet-managers/simplify-compliance-with-ELD-and-DVIR/',
    },
    {
        id: '06',
        imageUrl: 'https://www.spireon.com/wp-content/uploads/10470566-FleetLocate_LoginBanners_FL360-1024x430.jpg',
        imageAlt: 'FleetLocate FL360 banner',
        heading: 'Vehicle & Driver Intelligence for Any Vehicle Type',
        description: 'Our FL360 is a modular GPS tracking device that supports light, medium, and heavy-duty vehicles.',
        buttonText: 'Get Resources',
        buttonLink: 'https://www.spireon.com/products/fleetlocate-for-fleet-managers/fl-360/',
    },
    {
        id: '07',
        imageUrl: 'https://www.spireon.com/wp-content/uploads/10470566-FleetLocate_LoginBanners_FlexBatteryTracker-1024x430.jpg',
        imageAlt: 'FleetLocate Flex Battery Tracker banner',
        heading: 'The New Flex Battery Tracker Type',
        description: 'The Flex Battery Tracker sets a new standard with increased durability, extended battery life, and advanced theft prevention measures for unpowered assets such as trailers, equipment, containers, and more.',
        buttonText: 'Learn More',
        buttonLink: 'https://www.spireon.com/flex-battery-tracker/',
    },
    {
        id: '08',
        imageUrl: 'https://www.spireon.com/wp-content/uploads/10470566-FleetLocate_LoginBanners_CamCoach-1024x430.jpg',
        imageAlt: 'FleetLocate CamCoach banner',
        heading: 'AI Dashcam for Fleets',
        description: 'CamCoach is designed to coach your drivers on the go. Get access to video recordings from anywhere. A detailed view of distracted driving events are also available so you can reduce liability risk, encourage safe driving, reduce insurance premiums, and reduce costs of claims.',
        buttonText: 'See For Yourself',
        buttonLink: 'https://www.spireon.com/products/fleetlocate-for-fleet-managers/camcoach/',
    },
    {
        id: '09',
        imageUrl: 'https://www.spireon.com/wp-content/uploads/10470566-FleetLocate_LoginBanners_Flex2-1024x430.jpg',
        imageAlt: 'FleetLocate Flex 2 banner',
        heading: 'Trailer and Asset Tracking',
        description: 'Increase profitability and protect your assets from misuse or theft, with Flex 2. This covert GPS tracking device combines with intelligent cloud software, to give you actionable insights so you can make smarter business decisions faster.',
        buttonText: 'See For Yourself',
        buttonLink: 'https://www.spireon.com/products/fleetlocate-for-fleet-managers/fl-flex-2/',
    },
    {
        id: '10',
        imageUrl: 'https://www.spireon.com/wp-content/uploads/10470566-FleetLocate_LoginBanners_ELD-1024x430.jpg',
        imageAlt: 'FleetLocate ELD & DVIR banner',
        heading: 'Simplify Compliance with ELD & DVIR',
        description: 'Activate FL Compliance with Spireon’s FL360 to comply with the ELD Mandate, Hours of Service (HOS), Driver Vehicle Inspection Reporting (DVIR), and the International Fuel Tax Agreement (IFTA). Stay compliant, track your fleet, and monitor driver behavior from one online portal.',
        buttonText: 'Get Resources',
        buttonLink: 'https://www.spireon.com/solutions/fleet-managers/simplify-compliance-with-ELD-and-DVIR/',
    },
];
export default marketingPagesData;
